import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    light: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#107823",
        secondary: "#51565b",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },

  //#00a74a
});
